import { useMediaQuery } from "@/frontend/hooks/useMediaQuery";
import { RefObject, useEffect } from "react";

export const NavigationVariable = ({ navigationWrapperRef }: { navigationWrapperRef: RefObject<HTMLDivElement> | RefObject<null> }) => {
  const isSmallerViewport = useMediaQuery('only screen and (max-width : 1023px)');

  // Add CSS Variable for Navigation Menu Height (used in Navigation.scss)
  // trough isSmallerViewport we can adjust the height of the navigation menu if the window changes (it re-renders the component)

  useEffect(() => {
    const navWrapper =  navigationWrapperRef.current;

    if (navWrapper) {
      const height = navWrapper.offsetHeight;
      document.documentElement.style.setProperty('--NEXT__navigation-menu-height', `${height}px`);
    };

  }, [isSmallerViewport, navigationWrapperRef]);

  return (
    <></>
  );
};